
import imagePathsMixin from "@/mixins/getImagePaths";

export default {
  name: "ImageText",
  mixins: [imagePathsMixin],
  props: {
    content: Object,
  },
}
